import _ from 'lodash';;
import { observable, action, computed } from 'mobx';

export default class Document {
	store = null;

	constructor (store, data) {
		this.store = store;

		if (_.isEmpty(data)) {

			return;
		}

		this.update(data);
	}

	_id = null;
	get id () {
		return this._id;
	}

	set id (id) {
		this._id = id;
	}

	/**
	 * Observables & Computeds
	 */

 	@observable
 	_type = '';

 	@computed
 	get type () {
 		return this._type;
 	}

 	set type (type) {
 		this._type = type;
 	}

	@observable
	_title = '';

	@computed
	get title () {
		return this._title;
	}

	set title (title) {
		this._title = title;
	}

	@observable
	_content = '';

	@computed
	get content () {
		return this._content;
	}

	set content (content) {
		this._content = content;
	}

	@observable
	_orderIndex = -1;

	@computed
	get orderIndex () {
		return this._orderIndex;
	}

	set orderIndex (orderIndex) {
		this._orderIndex = orderIndex;
	}

	@computed
	get serialized () {
		return {
			_id: this._id,
			title: this._title,
			type: this._type
		};
	}

	/**
	 * Actions
	 */

	@action.bound
	async save (opts) {
		await this.store.saveDocument(this, opts);
	}

	@action.bound
	async delete () {
		this.store.deleteDocument(this);
	}

	@action
	update ({ _id, title, type}) {
		this.id = _.defaultTo(_id, this.id);
		this.title = _.defaultTo(title, this.title);
		this.type = _.defaultTo(type, this.type);
	}
}
